import { Component, OnInit } from '@angular/core';
import { ReportsService } from '../reports.service';
import { GlobalFunctionsService } from '../../common/functions/global-functions.service';
import { Unit } from '../../common/models/Unit.Model';
import { SettingsService } from 'src/app/core/settings/settings.service';
import { UserLogin } from '../../common/models/UserLogin.Model';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-rep-pieces-package',
  templateUrl: './rep-pieces-package.component.html',
  styleUrls: ['./rep-pieces-package.component.scss']
})
export class RepPiecesPackageComponent implements OnInit {

  downloading: boolean = false;
  working: boolean = false;
  esValidoRango: boolean = false;
  
  user: UserLogin | undefined;
  today: string | undefined;
  minDate: string | undefined;
  maxDate: string | undefined;

  // Listas
  organizacionList: Unit[] = [];
  region: Unit[] = [];
  nodesUser: Unit[] = [];
  
  // Selecciones
  organizationSelected: number = 0;
  regionSelected: string = '0';
  OriginNode: Unit = new Unit();

  constructor(
    private reportService: ReportsService,
    private globalFunctionService: GlobalFunctionsService,
    private settingsService: SettingsService
  ) { }

  ngOnInit(): void {
    this.globalFunctionService.canOperate();
    this.globalFunctionService.hasFSBRPending();

    this.user = this.settingsService.getUser();
    this.today = this.globalFunctionService.getStringDate(new Date(), false, 0);
    this.minDate = this.today;
    this.maxDate = this.today;

    this.getOrganizacion();
  }

  getOrganizacion(): void {
    if (!this.user) {
      this.globalFunctionService.messageToast('Usuario no disponible', 'error');
      this.working = false;
      return;
    }
    this.working = true;
    this.reportService.getOrganizacionesByUser(this.user.Org, this.user.Id).subscribe({
      next: (regiones: Unit[]) => {
        this.organizacionList = regiones;
        if (this.organizacionList.length > 0) {
          this.organizationSelected = this.organizacionList[0].UnitId;
          this.getRegion();
        }
      },
      error: () => this.globalFunctionService.messageToast('Error al obtener organización', 'error')
    });
  }

  getRegion() {
    if (!this.user) {
      this.globalFunctionService.messageToast('Usuario no disponible', 'error');
      this.working = false;
      return;
    }
    this.working = true;
    this.reportService.getUserRegions(this.user.Org, this.user.Id, this.organizationSelected.toString()).subscribe({
      next: (resp: Unit[]) => {
        this.region = resp;
        this.regionSelected = '0'; // Reset a TODOS
        this.getNodes();
      },
      error: () => this.working = false
    });
  }

  getNodes() {
    this.nodesUser = [];
    this.working = true;
    if (!this.user) {
      this.globalFunctionService.messageToast('Usuario no disponible', 'error');
      this.working = false;
      return;
    }
    this.reportService.getUserNodesByRegion(this.user.Org, this.user.Id, this.regionSelected).subscribe({
      next: (resp: any[]) => {
        resp.forEach(x => {
          if (x.UnitLevel !== 'Centro de Ventas') { // Solo FAB según lógica original
            let a = new Unit();
            a.UnitId = x.UnitId;
            a.OrgId = x.Org;
            a.UnitDescription = x.UnitDes;
            this.nodesUser.push(a);
          }
        });
        this.clearOriginNode();
      },
      error: () => this.globalFunctionService.messageToast('Error al obtener nodos', 'error'),
      complete: () => this.working = false
    });
  }

  onNodeChange(unitId: any) {
    const selected = this.nodesUser.find(n => n.UnitId == unitId);
    if (selected) {
      this.OriginNode = selected;
    } else {
      this.clearOriginNode();
    }
  }

  clearOriginNode() {
    this.OriginNode = new Unit();
    this.OriginNode.UnitId = 0;
  }

  async download(): Promise<void> {
    const nodeId = this.OriginNode.UnitId || 0;
    const unitName = this.OriginNode.UnitDescription || 'Global';

    await this.globalFunctionService.messageBimbo('Por favor espere...', 'loading', 'Generando reporte de piezas');
    this.downloading = true;

    this.reportService.getPiecesPackageReport(
      this.user!.Id, 
      nodeId, 
      this.organizationSelected.toString(), 
      this.regionSelected, 
      this.minDate || '', 
      this.maxDate || ''
    ).subscribe({
      next: (resp) => {
        Swal.close();
        const blob = new Blob([resp], { type: resp.type });
        const url = window.URL.createObjectURL(blob);
        const anchor = document.createElement('a');
        anchor.download = `Reporte_Piezas_Envase_${unitName}_${this.minDate}.xlsx`;
        anchor.href = url;
        anchor.click();
        window.URL.revokeObjectURL(url);
        
        this.downloading = false;
      },
      error: () => {
        Swal.close();
        this.downloading = false;
        this.globalFunctionService.messageToast('Error al generar el archivo', 'warning');
      }
    });
  }
}